import React, { useContext, useEffect } from "react";
import {
  Company,
  CompanyType,
  CountryType,
  ResultContext,
} from "../ResultContext";
import { Label } from "../components/Label";
import {
  CompanyTypeBelgium,
  CompanyTypeFrance,
  CompanyTypeGermany,
  CompanyTypeNetherlands,
  CompanyTypeUK,
  CompanyTypeUS,
} from "../constants/CompanyType";

export function filterCompanyType(country: string) {
  if (country === "Belgium") {
    return CompanyTypeBelgium;
  }
  if (country === "US") {
    return CompanyTypeUS;
  }
  if (country === "The Netherlands") {
    return CompanyTypeNetherlands;
  }
  if (country === "France") {
    return CompanyTypeFrance;
  }
  if (country === "UK") {
    return CompanyTypeUK;
  }
  if (country === "Germany") {
    return CompanyTypeGermany;
  } else {
    return "";
  }
}

export function CompanyName({
  questionId,
  label,
}: {
  questionId: number;
  label: string | undefined;
}) {
  const { result, setResult } = useContext(ResultContext);

  const foundResult = (result[questionId] as Company) || {
    name: "",
    country: CountryType.Belgium,
    type: "",
  };

  useEffect(() => {
    if (!result[questionId]) {
      const copy = { ...result };

      copy[questionId] = {
        name: "",
        country: CountryType.Belgium,
        type: "",
      };

      setResult(copy);
    }
    // eslint-disable-next-line
  }, [questionId]);

  return (
    <div className="flex flex-column">
      <Label
        title={label || ""}
        information={
          <>
            <div className="text-justify">
              Your legal company name is the name that you use on the paperwork
              when you incorporate your company.
            </div>
            <div className="mt-4 text-justify">
              Example: Google is the trade name or the name that the company is
              commonly known by, while its legal name is ‘Alphabet’.
            </div>
          </>
        }
      />
      <input
        type="text"
        placeholder={label}
        value={foundResult.name}
        onChange={(e) => {
          const copy = { ...result };

          copy[questionId] = { ...foundResult, name: e.target.value as string };

          setResult(copy);
        }}
      />
      <div className="mt-4">
        <div className="flex flex-row">
          <label className="mr-40">Country</label>
          <Label
            title={"Legal form"}
            information={
              <div>
                Under incorporation means that the company is not yet
                established/incorporated and has no legal form, yet.
              </div>
            }
          />
        </div>
        <div className="flex items-center">
          <select
            value={foundResult.country}
            onChange={(e) => {
              const copy = { ...result };

              copy[questionId] = {
                ...foundResult,
                country: e.target.value as CountryType,
              };

              setResult(copy);
            }}
          >
            {Object.values(CountryType).map((item, i) => {
              return (
                <option value={item} key={i}>
                  {item}
                </option>
              );
            })}
          </select>
          <div className="mr-4" />
          {foundResult.country !== "Other" ? (
            <select
              value={foundResult.type}
              onChange={(e) => {
                const copy = { ...result };

                copy[questionId] = {
                  ...foundResult,
                  type: e.target.value as CompanyType,
                };

                setResult(copy);
              }}
            >
              {Object.values(filterCompanyType(foundResult.country)).map(
                (item, i) => {
                  return (
                    <option value={item} key={i}>
                      {item}
                    </option>
                  );
                }
              )}
            </select>
          ) : (
            <input
              type="text"
              placeholder={"Company structure"}
              value={foundResult.type}
              onChange={(e) => {
                const copy = { ...result };

                copy[questionId] = {
                  ...foundResult,
                  type: e.target.value as string,
                };

                setResult(copy);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
